import React from "react";
import "./FeatureBoxList.scss";
import InfoBox from "../InfoBox/InfoBox";

interface FeatureItem {
  image: string;
  alt: string;
  text: string;
}

interface FeatureBoxListProps {
  features: FeatureItem[];
  className?: string;
}

const FeatureBoxList: React.FC<FeatureBoxListProps> = ({ features, className = "" }) => {
  return (
    <div className={`feature-box-list ${className}`}>
      {features.map((feature, index) => (
        <InfoBox
          key={index}
          className="feature-box"
          image={feature.image}
          alt={feature.alt}
          text={
            <p className="paragraph-small pw-info-box-text">
              {feature.text}
            </p>
          }
        />
      ))}
    </div>
  );
};

export default FeatureBoxList;
